import { render } from "./EvolAllocationChart.vue?vue&type=template&id=428055b7"
import script from "./EvolAllocationChart.vue?vue&type=script&lang=js"
export * from "./EvolAllocationChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__